import { useParams } from "react-router-dom";
import { UpdateContact } from "../components/contacts/update-contact";
import { ContactsContextWrapper } from "../hooks/ContactsContextWrapper";
import { UserContextWrapper } from "../hooks/UserContextWrapper";

export default function UpdateContactPage() {
  const { relationshipId } = useParams();

  return (
    <ContactsContextWrapper relationshipId={relationshipId}>
      <UserContextWrapper>
        <UpdateContact />
      </UserContextWrapper>
    </ContactsContextWrapper>
  );
}
